import { useRouteMatch } from 'react-router-dom'

import { UnityHubChannelIcon, TUnityHubChannelIconProps } from 'App/components/UnityHub'
import { UnityHubRoomNavLinkInline } from 'App/components/UnityHub/UnityHubRoomNavLinkInline'

type TCommunityHighlightRoomProps = {
  path: string
  name: string
  iconVariant: TUnityHubChannelIconProps['variant']
}

export const CommunityHighlightRoom = ({
  path,
  iconVariant,
  name
}: TCommunityHighlightRoomProps) => {
  const { url } = useRouteMatch()

  return (
    <UnityHubRoomNavLinkInline
      to={`${url}/${path}`}
      icon={<UnityHubChannelIcon variant={iconVariant} gutter={false} />}
      name={name}
    />
  )
}
